import { render, staticRenderFns } from "./ToggleMenu.vue?vue&type=template&id=1bbef254"
import script from "./ToggleMenu.vue?vue&type=script&lang=js"
export * from "./ToggleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports